import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Button } from "react-admin";
import Email from "@material-ui/icons/Email";
import Print from "@material-ui/icons/Print";
import { isNil, head, filter, map, prop, groupBy, propEq, uniq } from "ramda";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import ReactToPrint from "react-to-print";

const StyledH3 = styled.h3({
  color: "#ff9800",
  textTransform: "uppercase",
  paddingBottom: "15px"
});

const StyledGridHeader = styled(Grid)({
  padding: "10px",
  backgroundColor: "#ff9800",
  color: "#000000",
  textTransform: "uppercase"
});

const StyledGridElement = styled(Grid)({
  padding: "10px",
  color: "#000000",
  fontSize: "13px"
});

class clientsEmailsButton extends Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  state = {
    showDialog: false
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false, data: null });
  };

  languages = id => {
    const language = filter(propEq("id", id), [
      { id: "1", desc: "English" },
      { id: "2", desc: "Spanish" },
      { id: "3", desc: "German" },
      { id: "4", desc: "Portuguese" }
    ]);
    return prop("desc", head(language));
  };

  emailsByLanguage = (items, language) => {
    const emails = map(
      item => item.email,
      filter(propEq("language", language), items)
    );
    return uniq(emails).join("; ");
  };

  renderLanguagesEmails = clientsData => {
    const groupedData = groupBy(item => {
      return item.language;
    }, clientsData);
    return map(item => {
      const index = Math.random();
      return (
        <React.Fragment key={`${index}_${item}`}>
          <Grid container>
            <StyledGridHeader item xs={12} key={Math.random()}>
              {this.languages(item)}
            </StyledGridHeader>
          </Grid>
          <Grid container>
            <StyledGridElement item xs={12}>
              {this.emailsByLanguage(clientsData, item)}
            </StyledGridElement>
          </Grid>
        </React.Fragment>
      );
    }, Object.keys(groupedData));
  };

  renderContent = clientsData => {
    if (!isNil(clientsData)) {
      return (
        <React.Fragment>
          <Grid container>
            <Grid container>
              <StyledGridHeader item xs={2}>
                Id
              </StyledGridHeader>
              <StyledGridHeader item xs={5}>
                Name
              </StyledGridHeader>
              <StyledGridHeader item xs={5}>
                Email
              </StyledGridHeader>
            </Grid>
            {map(client => {
              return (
                <Grid container key={client.clientId}>
                  <StyledGridElement item xs={2}>
                    {client.clientId}
                  </StyledGridElement>
                  <StyledGridElement item xs={5}>
                    {client.name}
                  </StyledGridElement>
                  <StyledGridElement item xs={5}>
                    {client.email}
                  </StyledGridElement>
                </Grid>
              );
            }, clientsData)}
          </Grid>
        </React.Fragment>
      );
    }

    return "";
  };

  render() {
    const { showDialog } = this.state;
    const { data: clientsData } = this.props;
    return (
      <Fragment>
        <Email
          titleAccess="CLIENTS EMAILS"
          onClick={this.handleClick}
          cursor="pointer"
        />
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Clients Emails"
        >
          <DialogContent ref={this.componentRef}>
            <StyledH3>CLIENTS EMAILS</StyledH3>
            {this.renderContent(clientsData)}
            {this.renderLanguagesEmails(clientsData)}
          </DialogContent>
          <DialogActions>
            <ReactToPrint
              trigger={() => (
                <Button color="primary" onClick={this.nextClick} label="Print">
                  <Print />
                </Button>
              )}
              content={() => this.componentRef.current}
            />
            <Button label="Close" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(clientsEmailsButton);



// WEBPACK FOOTER //
// ./src/components/clientsEmails.js